<template>
  <v-container ma-0 pa-0>
    <EventFilterPanel @dateFilterChange="dateFilterChange"></EventFilterPanel>

    <v-timeline dense clipped class="mb-4 pa-0 mt-0">
      <!-- timeline day -->
      <TimelineDay v-for="(tlDay, tlDayIdx) in timelineDays" :day="tlDay" :key="tlDayIdx"></TimelineDay>
      <div class="load-more-button">
        <v-tooltip color="secondary" right>
          <v-btn v-if="true" slot="activator" icon dark color="secondary" @click="loadMore">
            <v-icon class="">keyboard_arrow_down</v-icon>
          </v-btn>
          <span>Load more</span>
        </v-tooltip>
      </div>
    </v-timeline>
  </v-container>
</template>

<script>
import { mapState } from "vuex"
import EventFilterPanel from "@/components/timeline/EventFilterPanel.vue"
import TimelineDay from "@/components/timeline/TimelineDay.vue"

export default {
  name: "Timeline",
  data: () => {
    return {
      expandShow: '',
      dateFrom: null,
      dateTo: null,
      filterExpandIcon: "filter_list",
      filtersVisible: false,
      page: 0,
      perPage: 10
    }
  },
  props: {
    timelineDays: Array,
    isCaseTimeline: Boolean
  },
  methods: {
    fetchEvents(loadMore) {
      const payload = {
        loadMore: loadMore,
        page: this.page,
        perPage: this.perPage,
        dateFrom: this.dateFrom,
        dateTo: this.dateTo
      }
      this.$store.dispatch("getFilteredEvents", payload)
    },
    loadMore: function () {
      this.page += 1
      this.fetchEvents(true)
    },
    dateFilterChange({ dateFrom, dateTo }) {
      this.dateFrom = dateFrom
      this.dateTo = dateTo
      this.page = 0
      this.perPage = 10
      this.fetchEvents(false)
    }
  },
  components: {
    EventFilterPanel,
    TimelineDay
  },
  computed: {
    ...mapState({
      eventsLoading: state => state.homepage.timeline.loading,
      timelineFilterIcons: state => state.timeline.timelineFilterIcons,
      getEventTypes: state => state.timeline.event_types,
      currentUserPreferences: state => state.currentUser.me.preferences,
      filterPreferencesLoading: state => state.currentUser.loading
    })
  }
}
</script>

<style>
.table-min-width-timeline {
  min-width: 440px;
}

.updated-field input {
  color: green !important;
}

.timeline-updates-list li {
  position: relative;
  padding: 0 0 5px 0;
}

.timeline-updates-list li:before {
  content: "\e5ca";
  position: absolute;
  left: -30px;
  top: -2px;
  width: 20px;
  font-family: "Material Icons";
  font-style: normal;
  font-weight: 400;
  font-size: 22px;
  color: #433e56;
}

#timeline_filters .v-avatar {
  cursor: pointer !important;
}

#timeline_filters .v-avatar[disabled] {
  background: rgba(0, 0, 0, 0.1);
  cursor: initial !important;
}

.timeline--icon .v-timeline-item__dot {
  box-shadow: initial !important;
  margin: -6px 0 0 0;
}

.timeline--icon .v-timeline-item__dot .v-icon {
  font-size: 26px
}

.eventDisabled .v-icon {
  -webkit-filter: grayscale(1);
  filter: grayscale(1);
}

.eventDisabled h3 {
  opacity: 0.5;
}

.timeline-expand-show {
  margin-top: 4px !important;
}

.timeline-date {
  display: inline-flex;
  vertical-align: middle !important
}

.timeline-user-avatar {
  margin-left: 10px;
  margin-top: 0px;
  vertical-align: middle;
}

.event-filter-title {
  width: 100%;
  float: left;
  padding: 0 0 20px 0;
  margin-top: -40px;
}

.timeline-on-grey .v-timeline-item__dot {
  background-color: rgb(230, 230, 230) !important;
}

.timeline-on-grey .v-timeline-item__dot .v-timeline-item__inner-dot {
  background-color: rgb(230, 230, 230) !important;
}
</style>

<style lang="scss" scoped>
.load-more-button {
  margin: 0;
  padding: 8px;
  height: 38px;
  width: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  z-index: 1000;
}
</style>
